<template>
	<div>

		<panel class="border border-secondary rounded mt-4 mb-4" :noButton="true" v-if="data.serviceType != 'Beli Sparepart'">
			<template slot="header">
				<h5>Pencarian Kendaraan</h5>
			</template>
			

			<b-form>
				<b-form-row>
					<b-form-group label="Cari Kendaraan Mobil" class="col-12">
						<Multiselect
							class="mt-1"
							:options="vehicleList"
							label="name"
							v-model="searchData"
							placeholder="Silahkan ketik deskripsi mobil yang dicari"
							:disabled="complain"
						/>
					</b-form-group>
				</b-form-row>
			</b-form>

			<button class="btn btn-outline-primary ml-1" type="button" @click="showCustomerForm = true">Input Mobil Baru</button>

		</panel>

		<panel class="border border-secondary rounded mb-4" :noButton="true" id="customer" v-if="(data.serviceType != 'Process Mobil' || data.customer.customer_id) && showCustomerForm">
			<template slot="header">
				<h5>Data Customer</h5>
			</template>
			
			
			<div >
				<b-form class="mt-3" v-if="!data.customer.customer_id">
					<b-form-row>
						<b-form-group label="Cari Data Customer" class="col-12">
						<Multiselect
							class="mt-1"
							:options="customerList"
							:custom-label="opt => opt.phone_number + ' - ' + opt.name"
							placeholder="Silahkan Ketik deskripsi customer yang dicari"
							v-model="customerData"
							:disabled="cariMobil || complain"
						/>
						</b-form-group>
					</b-form-row>
					<!-- <b-form-row>
						<button class="btn btn-outline-primary col-12" v-if="!showCustomerInput" @click="showCustomerInput = true">Input Customer Baru</button>
					</b-form-row> -->
					<b-form-row>
						<b-form-group label="Nama Pelanggan" class="col-md-6 col-12">
							<input id="customer_name"  type="text" class="form-control" v-model="data.customer.name" >
							<p v-if="error && error.customer_name" style='color:red'>{{error.customer_name}}</p>
						</b-form-group>
						<b-form-group label="Alias" class="col-md-6 col-12">
							<input id="alias" type="text" class="form-control" v-model="data.customer.alias" >
							<!-- <p v-if="error && error.customer_ktp" style='color:red'>{{error.customer_ktp}}</p> -->
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group label="Tanggal Lahir" class="col-md-6 col-12">
							<!-- <input type="text" class="form-control" v-model="data.customer.dob"> -->
							<flat-pickr
								v-model="data.customer.dob"
								:config="rangeConfig"
								placeholder="Pilih Tanggal"
							></flat-pickr>
						</b-form-group>
						<b-form-group label="Email" class="col-md-6 col-12">
							<input type="text" class="form-control" v-model="data.customer.email">
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group label="Tanggal Bergabung" class="col-md-6 col-12">
							<input type="text" class="form-control" v-model="data.customer.created_at" disabled>
						</b-form-group>
						<b-form-group label="Tanggal Kunjungan Terakhir" class="col-md-6 col-12">
							<input type="text" class="form-control" v-model="data.customer.last_date" disabled>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group label="Nomor Handphone" class="col-md-6 col-12">
							<input id="customer_phone_number" type="text" class="form-control" v-model="data.customer.phone_number" />
							<p v-if="error && error.customer_phone_number" style='color:red'>{{error.customer_phone_number}}</p>
						</b-form-group>
						<b-form-group label="Alamat" class="col-md-6 col-12">
							<input id="alamat" type="text" class="form-control" v-model="data.customer.address">
							<!-- <p v-if="error && error.customer_ktp" style='color:red'>{{error.customer_ktp}}</p> -->
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group label="Nomor KTP" class="col-12">
							<input id="customer_ktp" type="text" class="form-control" v-model="data.customer.ktp">
							<p v-if="error && error.customer_ktp" style='color:red'>{{error.customer_ktp}}</p>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group label="Unggah Gambar KTP" class="col-12">
							<input id="customer_ktp_img" type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize($event , 'ktp')" multiple/>
							<p v-if="error && error.customer_ktp_img" style='color:red'>{{error.customer_ktp_img}}</p>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-12">
							<img :src="env.baseImage + '/' + data.customer.ktp_img" v-if="data.customer.ktp_img != ''" class="img-fluid" style="max-height:300px ;min-width:25%;max-width:50%"/>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group label="Unggah Gambar SIM" class="col-12">
							<input id="customer_sim_img" type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize($event , 'sim')" multiple/>
							<p v-if="error && error.customer_sim_img" style='color:red'>{{error.customer_sim_img}}</p>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-12">
							<img :src="env.baseImage + '/' + data.customer_car.sim_img" v-if="data.customer_car.sim_img != ''" class="img-fluid" style="max-height:300px ;min-width:25%;max-width:50%"/>
						</b-form-group>
					</b-form-row>

					<button class="btn btn-success" @click="saveCustomer" type="button">Simpan Customer</button>
				</b-form>
				<b-form v-else class="text-cetner" @submit.prevent="console.log('haha')">
				
					<h6>Mobil Customer yang sudah di registrasi</h6>
					<table class="table mb-3">
						<thead>
							<th>No.</th>
							<th>Nomor Polisi</th>
							<th>Nomor Rangka</th>
						</thead>
						<tbody>
							<tr v-for="(vehicle , index) in vehicleList.filter(x=> x.customer_id == data.customer.customer_id)">
								<td>{{ index + 1 }}</td>
								<td>{{ vehicle.registration }}</td>
								<td>{{ vehicle.chassis_number }}</td>
								<!-- <td>{{ vehicle }}</td> -->
							</tr>
						</tbody>
					</table>
					<hr>
					<b-form-row>
						<b-form-group class="col-4">
							Nama Customer
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							<!-- {{data.customer.name}} ( {{data.customer.alias ? data.customer.alias : 'Tidak Ada Nama Alias'}} ) -->
							<input type="text" class="form-control" v-model="data.customer.name" />
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-4">
							Alias
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							<!-- {{data.customer.name}} ( {{data.customer.alias ? data.customer.alias : 'Tidak Ada Nama Alias'}} ) -->
							<input type="text" class="form-control" v-model="data.customer.alias" />
						</b-form-group>
					</b-form-row>
					
					<b-form-row>
						<b-form-group class="col-4">
							Nomor KTP
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							<!-- {{data.customer.ktp}} -->
							<input id="customer_ktp" type="text" class="form-control" v-model="data.customer.ktp" />
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-4">
							Alamat
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							<!-- {{data.customer.address}} -->
							<input id="customer_address" type="text" class="form-control" v-model="data.customer.address" />
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-4">
							Email
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							<!-- {{data.customer.email ? data.customer.email : '-'}} -->
							<input id="customer_email" type="text" class="form-control" v-model="data.customer.email" />
						</b-form-group>
						<!-- <b-form-group class="col-7 mt-auto mb-auto" v-else>
							<input type="text" class="form-control" v-model="tempEmail" />
						</b-form-group> -->
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-4">
							Tanggal Lahir
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							<!-- {{data.customer.dob ? data.customer.dob : '-'}} -->
							<flat-pickr
								v-model="data.customer.dob"
								:config="rangeConfig"
								placeholder="Pilih Tanggal"
								id="customer_dob"
							></flat-pickr>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-4">
							Tanggal Bergabung
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							{{data.customer.created_at}}
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-4">
							Tanggal Kunjungan Terakhir
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7">
							{{data.customer.last_date}}
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<b-form-group class="col-4 mt-auto mb-auto">
							Foto Ktp
						</b-form-group>
						<b-form-group class="col-1">
							:
						</b-form-group>
						<b-form-group class="col-7" v-if="data.customer.ktp_img">
							<img :src="env.baseImage + '/' + data.customer.ktp_img" v-if="data.customer.ktp_img != ''" class="img-fluid" style="max-height:300px ;min-width:25%;max-width:50%"/>
						</b-form-group>
						<b-form-group class="col-7" v-else>
							<input id="customer_ktp_img" type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize($event , 'ktp')" multiple/>
							<p v-if="error && error.customer_ktp_img" style='color:red'>{{error.customer_ktp_img}}</p>
						</b-form-group>
					</b-form-row>
					<b-form-row>
						<button class="btn btn-outline-warning mr-3 col-md-4 col-12" v-if="data.customer.customer_id" @click="resetCustomer">Ganti Customer</button>
					</b-form-row>
				</b-form>
			</div>
			
		</panel>

		<panel class="border border-secondary rounded mb-4" :noButton="true" id="car_beli_sparepart" v-if="data.serviceType == 'Beli Sparepart'">
			<template slot="header">
				<h5>Data Mobil Pelanggan (Optional)</h5>
			</template>

			<b-form-row>
				<b-form-group label="Merek Mobil" class="col-md-6 col-12">
					<Multiselect
						id="car_brand"
						class="mt-1"
						v-if="manualOptions.brand"
						:options="manualOptions.brand"
						label="name"
						v-model="data.brand"
						placeholder="Isi Merek Mobil"
					/>
					<p v-if="error && error.car_brand" style='color:red'>{{error.car_brand}}</p>
				</b-form-group>
				<b-form-group label="Tipe Mobil" class="col-md-6 col-12">
					<Multiselect
					id="car_type"
					class="mt-1"
					v-if="manualOptions.model"
					:options="manualOptions.model"
					label="name"
					v-model="data.model"
					placeholder="Isi Tipe Mobil"
					/>
					<p v-if="error && error.car_type" style='color:red'>{{error.car_type}}</p>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group label="Warna Mobil" class="col-md-6 col-12">
					<Multiselect
					id="car_color"
					class="mt-1"
					:options="options.color"
					label="name"
					v-model="data.colour"
					placeholder="Isi Warna Mobil"
					/>
					<p v-if="error && error.car_color" style='color:red'>{{error.car_color}}</p>
				</b-form-group>
				<b-form-group label="Tahun" class="col-md-6 col-12">
					<Multiselect
					id="car_year"
					class="mt-1"
					:options="options.year"
					v-model="data.year"
					placeholder="Isi Tahun Rakit Mobil"
					/>
					<p v-if="error && error.car_year" style='color:red'>{{error.car_year}}</p>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group label="Nomor Rangka" class="col-md-6 col-12">
					<input id="car_chassis_number" type="text" class="form-control" v-model="data.chassis_number"/>
					<!-- <p v-if="error && error.car_chassis_number" style='color:red'>{{error.car_chassis_number}}</p> -->
				</b-form-group>
				<b-form-group label="Nomor Mesin" class="col-md-6 col-12">
					<input id="car_engine_number" type="text" class="form-control" v-model="data.engine_number"/>
					<!-- <p v-if="error && error.car_engine_number" style='color:red'>{{error.car_engine_number}}</p> -->
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group label="Nomor Polisi Mobil" class="col-12">
					<input id="car_registration" type="text" class="form-control" v-model="data.registration"/>
					
				</b-form-group>
			</b-form-row>
		</panel>

		<panel class="border border-secondary rounded mb-4" :noButton="true" id="car" v-if="(data.customer.customer_id && data.serviceType != 'Beli Sparepart') || data.serviceType == 'Process Mobil'">
			<template slot="header">
				<h5>Data Mobil Pelanggan</h5>
			</template>
			

			<b-form >
				<b-form-row>
					<b-form-group label="Unggah Gambar STNK" class="col-12">
						<input id="car_stnk_img" type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize($event , 'stnk')" multiple/>
						<p v-if="error && error.car_stnk_img" style='color:red'>{{error.car_stnk_img}}</p>
					</b-form-group>
					
				</b-form-row>
				<b-form-row>
					<b-form-group class="col-12">
						<img :src="env.baseImage + '/' + data.customer_car.stnk_img" v-if="data.customer_car.stnk_img != ''" class="img-fluid" style="max-height:300px;min-width:25%;max-width:50%"/>
					</b-form-group>
				</b-form-row>
				<b-form-row>
					<b-form-group label="Merek Mobil" class="col-md-6 col-12">
						<Multiselect
							id="car_brand"
							class="mt-1"
							v-if="manualOptions.brand"
							:options="manualOptions.brand"
							label="name"
							v-model="data.customer_car.brand"
							placeholder="Isi Merek Mobil"
						/>
						<p v-if="error && error.car_brand" style='color:red'>{{error.car_brand}}</p>
					</b-form-group>
					<b-form-group label="Tipe Mobil" class="col-md-6 col-12">
						<Multiselect
						id="car_type"
						class="mt-1"
						v-if="manualOptions.model"
						:options="manualOptions.model"
						label="name"
						v-model="data.customer_car.model"
						placeholder="Isi Tipe Mobil"
						/>
						<p v-if="error && error.car_type" style='color:red'>{{error.car_type}}</p>
					</b-form-group>
				</b-form-row>
				<b-form-row>
					<b-form-group label="Warna Mobil" class="col-md-6 col-12">
						<Multiselect
						id="car_color"
						class="mt-1"
						:options="options.color"
						label="name"
						v-model="data.customer_car.colour"
						placeholder="Isi Warna Mobil"
						/>
						<p v-if="error && error.car_color" style='color:red'>{{error.car_color}}</p>
					</b-form-group>
					<b-form-group label="Tahun" class="col-md-6 col-12">
						<Multiselect
						id="car_year"
						class="mt-1"
						:options="options.year"
						v-model="data.customer_car.year"
						placeholder="Isi Tahun Rakit Mobil"
						/>
						<p v-if="error && error.car_year" style='color:red'>{{error.car_year}}</p>
					</b-form-group>
				</b-form-row>
				<b-form-row>
					<b-form-group label="Nomor Rangka" class="col-md-6 col-12">
						<input id="car_chassis_number" type="text" class="form-control" v-model="data.customer_car.chassis_number"/>
						<p v-if="error && error.car_chassis_number" style='color:red'>{{error.car_chassis_number}}</p>
					</b-form-group>
					<b-form-group label="Nomor Mesin" class="col-md-6 col-12">
						<input id="car_engine_number" type="text" class="form-control" v-model="data.customer_car.engine_number"/>
						<p v-if="error && error.car_engine_number" style='color:red'>{{error.car_engine_number}}</p>
					</b-form-group>
					<b-form-group class="col-md-4 col-12">
						<!-- <button class="w-100 btn btn-warning">Tidak Ada Nomor Rangka</button> -->
						<button type="button" class="btn btn-sm btn-outline-warning  pt-1 pb-1 pl-3 pr-3 " :disabled="data.customer_car.chassis_number != '' && data.customer_car.chassis_number != null" @click="generateNoRangka()">Jika nomor rangka dan mesin tidak tersedia, klik disini</button>
					</b-form-group>
				</b-form-row>
				<b-form-row>
					<b-form-group label="Nomor Polisi Mobil" class="col-md-12 col-12">
						<input id="car_registration" type="text" class="form-control" v-model="data.customer_car.registration" maxlength ="11"/>
						<p v-if="error && error.car_registration" style='color:red'>{{error.car_registration}}</p>
					</b-form-group>
				</b-form-row>
				

				<b-form-row>
					<!-- <b-form-group label="Harga Mobil" class="col-6">
						<input id="car_price" type="text" pattern="^[0-9]+$" class="form-control" v-model="data.customer_car.price"/>
						<p v-if="error && error.car_price" style='color:red'>{{error.car_price}}</p>
					</b-form-group>
					<b-form-group class="col-6" label="Kategori Pricelist Asuransi">
						<input type="text" disabled class="form-control" v-model="priceCondition"/>
					</b-form-group> -->
					<b-form-group class="col-12" label="Permintaan Customer">
						<input type="text" class="form-control" v-model="customerRequest"/>
					</b-form-group>
				</b-form-row>
				
			</b-form>
		</panel>

		<div class="row">
			<div class="col-md-9 col-0">
			</div>
			<div class="col-md-3 col-6">
				<button type="button" class="btn btn-primary w-100 rounded" :disabled="apiLoading" @click="nextPage()">Berikutnya</button>
			</div>
		</div>


		<adminAuth
			v-if="modal.showAdminAuth"
			@closeModal="modal.showAdminAuth = false"
			:reason="reason"
			:request="
				`Nomor Rangka dan mesin tidak tersedia dalam perekapan data.`
			"
			@approved="allowGenerateNoRangka"
			@token="generateNoRangka"
		/>


	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'

	import Datepicker from 'vuejs-datepicker'
	import moment from 'moment'
	import env from '@/env'
	// import uuid from 'uuid'
	// const { 
	// 	v1: uuidv1,
	// 	v4: uuidv4,
	// } = require('uuid');
	import adminAuth from '@/components/modal/adminAuthorization'
	const ShortUniqueId = require('short-unique-id')
	const chassis = new ShortUniqueId({ length: 21 });
	const mesin = new ShortUniqueId({ length: 11 });

	export default {
		data () {
			return {
				env,
				error : null,
				modal : {
					showAdminAuth : false
				},
				reason : '',
				// new vars 
				showCustomerInput : false,
				showCustomerForm : false ,
				//end new vars
				
				options: this.$store.getters.getFilterOptions,
				vehicleList: [],
				searchData: null,
				quotationList: [],
				chosenData: null,
				complainList : [],
				customerData: null,
				customerDisabled: false,
				fileErrorktp : '',
				referenceWorkOrder : 'New Work Order',
				complain : false,
				listInsuraceCarTypes : [],
				priceCondition : '-',
				cariMobil : false,
				complain : false,
				customerRequest : '',
				manualOptions : {
					brand : null,
					model : null,
					modelFull : null
				},
				processMobilList : null,
				rangeConfig: {
					altInput: true,
					altInputClass: 'form-control input w-100 bg-white',
					animate: !this.isRTL()
				},
				tempEmail : '',
				apiLoading : false
			}
		},
		props: ['page', 'data', 'skip' , 'allowMerge' , 'customerList' , 'searchChassis'],
		components: {
			Multiselect,
			Datepicker,
			adminAuth
		},
		mounted() {
			var urlBrand = `/api/v1/masterData/car/brand?pagination=false`
			var urlType =  `/api/v1/masterData/car/model?pagination=false`

			if(this.data.customer.customer_id)
				this.showCustomerForm = true

			this.$http.get(urlBrand).then((resp) => {
				this.manualOptions.brand = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})

			this.$http.get(urlType).then((resp) => {
				this.manualOptions.modelFull = resp.data.data
				this.manualOptions.model = JSON.parse(JSON.stringify(this.manualOptions.modelFull))
			})
			.catch((err) => {
				console.log(err)
			})

			this.$http.get('/api/v1/workorder/chassis/get?pagination=false')
			.then((resp) => {
				this.vehicleList = resp.data.data

				for (var i = 0 ; i < this.vehicleList.length ; i++) {
					this.vehicleList[i].name = `${this.vehicleList[i].chassis_number} - ${this.vehicleList[i].registration} - ${this.vehicleList[i].name}`
				}
			})
			.catch((err) => {
				console.log(err)
			})


			


		},
		watch: {
			searchChassis : function () {
				console.log('a')
				if(this.searchChassis ) {
					this.searchData = this.vehicleList.find(x => x.chassis_number == this.searchChassis)
				}
			},
			'data.serviceType' : function () {
				if(this.data.serviceType == 'Beli Sparepart') {
					this.showCustomerForm = true
				}

			},
			customerRequest : function() {
				this.$emit('emitCQ' , this.customerRequest)
			},
			'data.customer_car.model' : function () {
				this.data.customer_car.car_id = this.data.customer_car.model.id
			},
			'data.customer_car.chassis_number' : function () {
				const result = this.data.customer_car.chassis_number.toUpperCase();
				this.$nextTick(() => this.data.customer_car.chassis_number = result);
			},
			'data.customer_car.registration' : function () {
				const result = this.data.customer_car.registration.toUpperCase();
				this.$nextTick(() => this.data.customer_car.registration = result);
			},
			'data.customer_car.engine_number' : function () {
				const result = this.data.customer_car.engine_number.toUpperCase();
				this.$nextTick(() => this.data.customer_car.engine_number = result);
			},
			
			'data.customer.ktp' : function () {
				const result = this.data.customer.ktp.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
				this.$nextTick(() => this.data.customer.ktp = result);
			},
			'data.customer_car.brand' : function () {
				// this.options.model = this.$store.getters.getSingleModelId(this.data.customer_car.brand.id)
				// console.log(this.manualOptions.modelFull , this.data.customer_car.brand)c
				this.manualOptions.model = this.manualOptions.modelFull.filter(x => x.brand_id == this.data.customer_car.brand.id)
			},
			'data.brand' : function () {
				// this.options.model = this.$store.getters.getSingleModelId(this.data.customer_car.brand.id)
				// console.log(this.manualOptions.modelFull , this.data.customer_car.brand)c
				this.manualOptions.model = this.manualOptions.modelFull.filter(x => x.brand_id == this.data.brand.id)
			},
			customerData :function () {
					if(!this.customerData) {
						this.data.customer.name = ''
						this.data.customer.alias = ''
						delete this.data.customer.customer_id 
						this.data.customer.phone_number = ''
						this.data.customer.created_at = moment().format('MMMM, DD Y')
						this.data.customer.ktp = ''
						this.data.customer.ktp_img = ''
						this.data.customer.address = ''
						this.data.customer_car.sim_img = ''
						this.data.customer.email = ''
						this.data.customer.last_date = new moment().format('MMMM, DD Y')
						this.customerDisabled = false
						this.customerData.dob = ''
						return;
					}

					this.data.customer.name = this.customerData.name
					this.data.customer.alias = this.customerData.alias
					this.data.customer.email = this.customerData.email
					this.data.customer.customer_id = this.customerData.id
					this.data.customer.phone_number = this.customerData.phone_number
					this.data.customer.created_at = moment(this.customerData.created_at).format('MMMM, DD Y')
					this.data.customer.ktp = this.customerData.ktp
					this.data.customer.dob = this.customerData.dob
					this.data.customer.address = this.customerData.address
					this.data.customer.ktp_img = this.customerData.ktp_img
					this.data.customer_car.sim_img = this.customerData.sim_img
					this.data.customer.last_date = this.customerData.last_date ? new moment(this.customerData.last_date).format('MMMM, DD Y') : new moment().format('MMMM, DD Y')
					this.customerDisabled = true
					this.showCustomerInput = true
			},
			searchData : function () {
				if(!this.searchData) {
					this.cariMobil = false
					return;
				}

				this.cariMobil = true

				this.$http.get('/api/v1/workorder/chassis/fetch/' + this.searchData.chassis_number)
				.then((resp) => {
					let data = resp.data.data[0]
					// console.log(data)
					this.data.customer.name = data.name
					this.data.customer.customer_id = data.id
					this.data.customer.phone_number = data.phone_number
					this.data.customer.ktp = data.ktp
					this.data.customer.address = data.address
					this.data.customer.email = data.email
					this.data.customer.dob = data.dob
					this.data.customer.ktp_img = data.ktp_img
					this.data.customer.alias = data.alias
					this.data.customer.dob = data.dob
					this.data.customer.created_at = data.created_at ? moment(data.created_at).format('MMMM, DD Y') : new moment().format('MMMM, DD Y')
					this.data.customer.last_date = data.last_date ? new moment(data.last_date).format('MMMM, DD Y') : new moment().format('MMMM, DD Y')
					
					
					this.data.customer_car.stnk_img = data.stnk_img
					this.data.customer_car.sim_img = data.sim_img
					if(!this.searchChassis) {
						this.data.customer_car.engine_number = data.engine_number
						this.data.customer_car.chassis_number = data.chassis_number
						this.data.customer_car.year = data.year
						this.data.customer_car.colour = {
							id : data.color_id,
							name: data.color_name
						}
					}
					
					this.data.customer_car.registration = data.registration
					this.data.customer_car.last_km = this.numberWithCommas(data.last_km)
					this.data.customer_car.car_id = data.car.id
					this.data.customer_car.brand = {
						id : data.car.brand_id,
						name: data.car.cb.name
					}

					this.data.customer_car.model = {
						brand_id : data.car.brand_id,
						brand_name: data.car.cb.name,
						id : data.car.id,
						name: data.car.name
					}
					this.showCustomerInput = true
					this.showCustomerForm = true
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		methods: {
			async generateNoRangka(token = null) {
				let prevToken = "";

				if (token) {
					prevToken = this.$http.defaults.headers.common["Authorization"];

					this.$http.defaults.headers.common["Authorization"] =
						"Bearer " + token;
				}

				this.$http
					.get("/api/v1/check")
					.then((resp) => {
						let data = resp.data.data;
						let super_user = data.is_superuser;

						if (super_user) {
							this.allowGenerateNoRangka(token , prevToken);
						} else {
							this.modal.showAdminAuth = true;
							this.reason = token
								? "Akun tersebut tidak punya access untuk fitur ini. Mohon dicoba dengan Akun lainnya."
								: "Untuk Memakai Fitur Ini, Diperlukan Otorisasi Administrator.";
						}
					})
					.catch((err) => {
						console.log(err);
					});
			},
			allowGenerateNoRangka(token , prevToken) {
				this.modal.showAdminAuth = false;

				if (token) {
					this.$http.defaults.headers.common["Authorization"] = prevToken;
				}
				this.$store.dispatch("triggerAlert", [
					true,
					"Admin Permission Success",
				]);

				this.data.customer_car.chassis_number = 'RAND' + chassis();
				this.data.customer_car.engine_number = 'RAND'+ mesin();


				// this.$emit('deleteEstimations' , id)


			},
			async saveCustomer () {
				let dataCustomer = JSON.parse(JSON.stringify(this.data.customer))
				console.log(dataCustomer)

				dataCustomer.ktp = dataCustomer.ktp.split(' ').join('')

				if(!dataCustomer.customer_id) delete dataCustomer.customer_id

				

				dataCustomer.updated_at = new moment(dataCustomer.last_date).format('Y-MM-DD')
				// dataCustomer.created_at = new moment(dataCustomer.created_at).format('Y-MM-DD')
				delete dataCustomer.created_at
				delete dataCustomer.last_date
				if(await this.validateFormCustomer()) {
					this.$http.post('/api/v1/masterData/customer' , dataCustomer)
					.then((resp) => {
						// console.log(resp.data.data)
						// this.data.customer.customer_id = resp.data.data.id
						this.$set(this.data.customer , 'customer_id' , resp.data.data.id)
						console.log(this.data.customer)
					})
					.catch((err) => {
						console.log(err.response)
						// this.$set(this.valid, curIndex, false)
						let errMessage = err.response.data.data
						if(typeof errMessage == 'string') {
							if(errMessage.includes('registration'))
								errMessage = errMessage.replace('registration' , 'Nomor Polisi Mobil')

							this.$store.dispatch('triggerAlert' , [false , errMessage])
							this.apiLoading = false
						}
						else if(errMessage.nativeError) {
							this.$store.dispatch('triggerAlert' , [false , errMessage.nativeError.sqlMessage])
						}
						else {
							let keys = Object.keys(errMessage)
							let arr = []
							for(var i = 0 ; i < keys.length ; i++) {
								let message = errMessage[keys[i]][0].message
								arr.push(`${this.translate(keys[i])} ${message}`)

							}
							this.$store.dispatch('triggerAlert' , [false , arr])
							this.apiLoading = false
						}
					})
				}
				
			},
			resetCustomer () {
				this.data.customer = {
					name: '',
					alias: '',
					phone_number: '',
					created_at: new moment().format('Y-MM-DD'),
					last_date: new moment().format('Y-MM-DD'),
					ktp : '',
					ktp_img : '',
					
				}
				this.cariMobil = false
				this.customerData = null
			},

			validateSize : function(data, type){
			
				var file = data.target.files[0];

				var size  = file.size / 1024 / 1024;

				if(size > 20)
				{
					this['fileError' + type] = "Limit Size Gambar 8 MB";
					return false;
				}

				let url = env.urlStart + "/api/v1/workorder/image"
				let formData = new FormData()

                formData.append('work_order' , file)
                
                this.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
                .then((resp) => {
                   
					type == 'ktp' ? this.data.customer[type + '_img'] = resp.data.data.filename : this.data.customer_car[type + '_img'] = resp.data.data.filename
                })
                .catch((err) => {
                    console.log(err)
                })


				return true;
			},
			errorStyleText (id) {
				var elem = document.getElementById(id);
				var css = { color: 'red'};
				Object.assign(elem.style, css);
			},
			revertStyleText (id) {
				var elem = document.getElementById(id);
				var css = { color: 'black'};
				Object.assign(elem.style, css);
			},
			errorStyle (id) {
				var elem = document.getElementById(id);
				var css = { border: '1px solid red'};
				Object.assign(elem.style, css);
			},
			revertStyle (id) {
				var elem = document.getElementById(id);
				if(!elem) return
				var css = { border: '1px solid #d5dbe0'};
				Object.assign(elem.style, css);
			},
			errorScroll (id) {
				document.getElementById(id).scrollIntoView({
					behavior: 'smooth'
				});
			},
			async validateFormCustomer () {
				var valid = true;
				var error = {};
				this.error = null;
				let scroll = false

				//CHECK INFORMASI PELANGGAN
				if(this.data.customer.name == '' || this.data.customer.name == null){//Nama Pelanggan [Required]
					valid = false;

					if(!scroll) {
						this.errorScroll('customer')
						scroll = true
					}
					this.errorStyle('customer_name')
					
					error.customer_name = 'Nama pelanggan wajib terisi';

				}
				else {
					error.customer_name = null
					this.revertStyle('customer_name')
				}

				if(this.data.customer.address == '' || this.data.customer.address == null){//Alamat Pelanggan [Required]
					valid = false;

					if(!scroll) {
						this.errorScroll('customer')
						scroll = true
					}
					this.errorStyle('customer_address')
					
					error.customer_name = 'Alamat pelanggan wajib terisi';

				}
				else {
					error.customer_name = null
					this.revertStyle('customer_address')
				}

				if(this.data.customer.phone_number == '' || this.data.customer.phone_number == null){//Nomor Handphone [Required]
					valid = false;

					if(!scroll) {
						this.errorScroll('customer')
						scroll = true
					}
					this.errorStyle('customer_phone_number')

					error.customer_phone_number = 'Nomor handphone wajib terisi';
				}
				else if(this.data.customer.phone_number.length > 17) {
					valid = false;

					if(!scroll) {
						this.errorScroll('customer')
						scroll = true
					}
					this.errorStyle('customer_phone_number')

					error.customer_phone_number = 'Nomor handphone tidak boleh lebih dari 17 digit';
				}
				else {
					error.customer_phone_number = null
					this.revertStyle('customer_phone_number')
				}

				let ktp = this.data.customer.ktp.split(' ').join('')
				console.log(ktp)


				if(this.data.customer.ktp == '' || this.data.customer.ktp == null){//Nomor Handphone [Required]
					valid = false;

					if(!scroll) {
						this.errorScroll('customer')
						scroll = true
					}
					this.errorStyle('customer_ktp')
					error.customer_ktp = 'Nomor KTP wajib terisi.';
				}
				else if (ktp.length != 16) {
					valid = false;

					if(!scroll) {
						this.errorScroll('customer')
						scroll = true
					}
					this.errorStyle('customer_ktp')
					error.customer_ktp = 'Nomor KTP Tidak Boleh Lebih Panjang Atau Kurang Dari 16 Digit.';
				}
				else {
					error.customer_ktp = null
					this.revertStyle('customer_ktp')
				}

				if(this.data.customer.ktp_img == '' || this.data.customer.ktp_img == null){//Tanggal Kunjungan Terakhir [Required]
					valid = false;

					if(!scroll) {
						this.errorScroll('customer')
						scroll = true
					}
					this.errorStyle('customer_ktp_img')
					error.customer_ktp_img = 'Foto KTP wajib di unggah.';
				}
				else {
					error.customer_ktp_img = null
					this.revertStyle('customer_ktp_img')
				}
				this.error = error
				return valid;
			},
			async validateForm(){
				var valid = true;
				var error = {};
				this.error = null;
				let scroll = false

				if(this.data.serviceType == 'Beli Sparepart')
					return valid

				// //CHECK INFORMASI MOBIL PELANGGAN

				if(this.data.customer_car.stnk_img == '' || this.data.customer_car.stnk_img == null){//Tanggal Kunjungan Terakhir [Required]
					valid = false;

					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					this.errorStyle('car_stnk_img')
					error.car_stnk_img = 'Gambar STNK wajib terunggah';
				}
				else {
					error.car_stnk_img = null
					this.revertStyle('car_stnk_img')
				}

				if(this.data.customer_car.brand == '' || this.data.customer_car.brand == null){//Merk Mobil [Required]
					valid = false;
					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					error.car_brand = 'Merk mobil wajib terisi';
				}
				else {
					error.car_brand = null
				}

				if(this.data.customer_car.model == '' || this.data.customer_car.model == null){//Tipe Mobil [Required]
					valid = false;
					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					error.car_type = 'Tipe mobil wajib terisi';
				}
				else {
					error.car_type = null
				}


				if(this.data.customer_car.colour == '' || this.data.customer_car.colour == null){//Warna Mobil [Required]
					valid = false;
					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					error.car_color = 'Warna mobil wajib terisi';
				}
				else {
					error.car_color = null
				}
				

				if(this.data.customer_car.year == '' || this.data.customer_car.year == null){//Tahun [Required]
					valid = false;
					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					error.car_year = 'Tahun mobil wajib terisi';
				}
				else {
					error.car_year = null
				}

				if(this.data.customer_car.chassis_number == '' || this.data.customer_car.chassis_number == null){//Nomor Rangka [Required]
					valid = false;
					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					this.errorStyle('car_chassis_number')
					error.car_chassis_number = 'Nomor rangka wajib terisi';
				}
				else {
					error.car_chassis_number = null
					this.revertStyle('car_chassis_number')
				}

				if(this.data.customer_car.engine_number == '' || this.data.customer_car.engine_number == null){//Nomor Mesin [Required]
					valid = false;
					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					this.errorStyle('car_engine_number')
					error.car_engine_number = 'Nomor mesin wajib terisi';
				}
				else {
					error.car_engine_number = null
					this.revertStyle('car_engine_number')
				}

				if(this.data.customer_car.registration == '' || this.data.customer_car.registration == null){//Nomor Polisi Mobil [Required]
					valid = false;
					if(!scroll) {
						this.errorScroll('car')
						scroll = true
					}
					this.errorStyle('car_registration')
					error.car_registration = 'Nomor polisi mobil wajib terisi';
				}
				else {
					error.car_registration = null
					this.revertStyle('car_registration')
				}

				this.error = error
				return valid;
			},

			async nextPage () {
				let allowNextPage = await this.validateForm() && await this.validateFormCustomer()
				console.log(allowNextPage)
				if(allowNextPage) {
					this.$emit('nextPage' , this.tempEmail)
				}
				// 
			}
		},
	}
</script>

<style scoped>
.selected {
		border : 5px solid rgba(0,88,168,1) !important;
	}

	.hoverable:hover {
		color : white;
		background-color : #448;
	}
</style>